/**
 * 이미지 파일에서 EXIF orientation 정보를 제거합니다.
 * Canvas를 사용하여 이미지를 다시 그려서 메타데이터 없이 새 파일을 생성합니다.
 * @param {File} file - 원본 이미지 파일
 * @returns {Promise<File>} - EXIF 정보가 제거된 새 이미지 파일
 */
export async function removeExifOrientation(file) {
  return new Promise((resolve, reject) => {
    // 이미지 파일이 아니면 원본 반환
    if (!file.type.startsWith("image/")) {
      resolve(file);
      return;
    }

    const reader = new FileReader();

    reader.onload = (e) => {
      const img = new Image();

      img.onload = () => {
        // Canvas 생성
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        // 원본 크기 유지
        canvas.width = img.width;
        canvas.height = img.height;

        // 이미지를 Canvas에 그리기 (EXIF 정보 제거됨)
        ctx.drawImage(img, 0, 0);

        // Canvas를 Blob으로 변환
        canvas.toBlob(
          (blob) => {
            if (blob) {
              // 새 File 객체 생성 (원본 파일명과 타입 유지)
              const newFile = new File([blob], file.name, {
                type: file.type,
                lastModified: Date.now(),
              });
              resolve(newFile);
            } else {
              reject(new Error("Canvas to Blob 변환 실패"));
            }
          },
          file.type,
          0.95 // 품질 (0.95 = 95% 품질)
        );
      };

      img.onerror = () => {
        reject(new Error("이미지 로드 실패"));
      };

      img.src = e.target.result;
    };

    reader.onerror = () => {
      reject(new Error("파일 읽기 실패"));
    };

    reader.readAsDataURL(file);
  });
}

/**
 * 여러 이미지 파일에서 EXIF orientation 정보를 제거합니다.
 * @param {FileList|File[]} files - 이미지 파일 목록
 * @returns {Promise<File[]>} - EXIF 정보가 제거된 이미지 파일 배열
 */
export async function removeExifOrientationFromFiles(files) {
  const fileArray = Array.from(files);
  const promises = fileArray.map((file) => removeExifOrientation(file));
  return Promise.all(promises);
}

